import type { Money } from './money';

export function formatMoney(money: Money, locale = 'ru-RU'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: money.currency,
    minimumFractionDigits: money.fractionDigits,
    maximumFractionDigits: money.fractionDigits,
  }).format(money.amountMinor / 10 ** money.fractionDigits);
}

/** Whole number with Russian digit grouping ("1 116" bonuses). */
export function formatNumber(value: number, locale = 'ru-RU'): string {
  return new Intl.NumberFormat(locale).format(value);
}
